import { render, staticRenderFns } from "./RolesDrawerSide.vue?vue&type=template&id=41d6e00c&scoped=true&"
import script from "./RolesDrawerSide.vue?vue&type=script&lang=js&"
export * from "./RolesDrawerSide.vue?vue&type=script&lang=js&"
import style0 from "./RolesDrawerSide.vue?vue&type=style&index=0&id=41d6e00c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d6e00c",
  null
  
)

export default component.exports